import Link from "next/link";

import useShop from "../../hooks/useShop.hook";
import { Customer } from "../../types/customer";
import { format } from "date-fns";
import localeCore from "../../core/locale.core";
import LoadingOvalIcon from "../../icons/loadingOval.icon";

export default function CustomerListRow({
  customer,
  rewardPoints,
  rewardPointsLoading,
  giftCardPoints,
  giftCardPointsLoading,
}: {
  customer: Customer;
  rewardPoints?: number;
  rewardPointsLoading: boolean;
  giftCardPoints?: number;
  giftCardPointsLoading: boolean;
}) {
  const selectedShop = useShop();

  if (!selectedShop) return null;

  return (
    <div
      attr-email={customer.email}
      attr-type="product-row"
      className="w-full max-w-[1200px] grid grid-cols-[1fr_1fr] lg:grid-cols-[300px_100px_170px_60px_60px_100px_160px_140px] gap-0 lg:gap-6 py-3 border-b-[1px]"
    >
      <div className="col-span-2 lg:col-span-1">
        <Link data-email={customer.email} className="underline email" href={`/customer/${customer.id}`}>
          {customer.email}
        </Link>
      </div>
      <div className="col-span-2 lg:col-span-1">
        {customer.firstName} {customer.lastName}
      </div>
      <div>{customer.mobileNumber}</div>
      <div>{customer.provider}</div>
      <RewardPoints rewardPoints={rewardPoints} rewardPointsLoading={rewardPointsLoading} />
      <GiftCardPoints giftCardPoints={giftCardPoints} giftCardPointsLoading={giftCardPointsLoading} />
      <div>{format(new Date(customer?.createdAt), "yyyy-MM-dd HH:mm:ss")}</div>
      <div className="hidden lg:block">
        <Membership customer={customer} />
      </div>
    </div>
  );
}

function Membership({ customer }: { customer: Customer }) {
  if (!customer.membership) return null;

  return (
    <>
      {customer.membership
        .filter((m) => m.isActive)
        .map((m) => {
          return (
            <div key={m.id}>
              <p className="font-bold text-admin-green text-right">{localeCore.getLocaleValueDefaultFallback(m.name)}</p>
            </div>
          );
        })}
    </>
  );
}

function RewardPoints({ rewardPoints, rewardPointsLoading }: { rewardPoints?: number; rewardPointsLoading: boolean }) {
  if (rewardPointsLoading)
    return (
      <div className="hidden lg:block text-right">
        <LoadingOvalIcon className="w-6 h-6 inline" />
      </div>
    );

  return <div className="hidden lg:block text-right">{rewardPoints ?? 0}</div>;
}

function GiftCardPoints({
  giftCardPoints,
  giftCardPointsLoading,
}: {
  giftCardPoints?: number;
  giftCardPointsLoading: boolean;
}) {
  if (giftCardPointsLoading)
    return (
      <div className="hidden lg:block text-right">
        <LoadingOvalIcon className="w-6 h-6 inline" />
      </div>
    );

  return <div className="hidden lg:block text-right">{giftCardPoints ?? 0}</div>;
}
